<template>
  <BaseModal
    :is-open="isOpen"
    title="계좌비밀번호"
    :show-default-footer="false"
    :close-on-overlay-click="false"
    :close-on-escape="true"
    content-padding="none"
    @close="handleClose"
    @update:is-open="$emit('update:isOpen', $event)"
  >
    <div class="px-padding-36 flex flex-col justify-center py-10">
      <div class="gap-size-12 flex flex-col">
        <p class="text-font-18 font-medium">계좌 비밀번호 입력</p>
        <p v-if="!props.isOpneApi" class="text-font-14">계좌 비밀번호를 입력해주세요</p>
        <p v-else class="text-font-14">API key 발급을 위해 비밀번호 확인이 필요해요</p>
      </div>

      <div class="gap-size-12 mt-size-36 flex flex-col">
        <BasePIN :pin="password" @key-press="handleKeyPress" />
      </div>
    </div>
    <!-- 푸터 영역 -->
    <template #footer>
      <div class="flex items-center justify-center gap-3">
        <BaseButton
          variant="contained"
          color="primary"
          :label="!props.isOpneApi ? '입력완료' : '확인'"
          :disabled="isConfirmDisabled"
          @click="handleAgree"
          fullWidth
        />
        <BaseButton
          v-if="props.isOpneApi"
          variant="outlined"
          color="white"
          label="취소"
          @click="handleClose"
          fullWidth
        />
      </div>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { BaseModal, BaseButton, BasePIN } from '@template/ui';
import { computed, ref } from 'vue';

const props = withDefaults(
  defineProps<{
    isOpneApi?: boolean;
  }>(),
  {
    isOpneApi: false,
  }
);

const isOpen = defineModel<boolean>('isOpen', { required: true });
const password = ref<string[]>([]);

interface Emits {
  (e: 'close'): void;
  (e: 'confirm', password: string): void;
  (e: 'update:isOpen', value: boolean): void;
}

const emit = defineEmits<Emits>();

const isConfirmDisabled = computed(() => {
  return password.value.length !== 6;
});

const handleClose = () => {
  password.value = [];
  emit('close');
  emit('update:isOpen', false);
};

const handleAgree = () => {
  if (password.value.length === 6) {
    emit('confirm', password.value.join(''));
    handleClose();
  }
};

const KEYPAD_SPECIAL_KEYS = {
  BACKSPACE: 'BACKSPACE',
  EMPTY: 'EMPTY',
} as const;

const handleKeyPress = (key: string) => {
  if (key === KEYPAD_SPECIAL_KEYS.BACKSPACE) {
    password.value = password.value.slice(0, -1);
  } else {
    password.value.push(key);
  }
};
</script>
